import React, { useRef } from 'react'
import { motion, useMotionValue, useSpring, useReducedMotion } from 'framer-motion'

/**
 * Button that leans toward the cursor while it is nearby and springs back
 * when the pointer leaves. Pointer-driven only, so it stays inert on touch
 * devices and when the visitor has asked for reduced motion.
 */
const MagneticButton = ({ children, className, onClick, strength = 0.35, type = 'button', ...rest }) => {
  const ref = useRef(null)
  const reduced = useReducedMotion()
  const x = useMotionValue(0)
  const y = useMotionValue(0)
  const springX = useSpring(x, { stiffness: 260, damping: 18, mass: 0.4 })
  const springY = useSpring(y, { stiffness: 260, damping: 18, mass: 0.4 })

  const handleMove = (event) => {
    if (reduced || !ref.current || event.pointerType === 'touch') return
    const rect = ref.current.getBoundingClientRect()
    x.set((event.clientX - (rect.left + rect.width / 2)) * strength)
    y.set((event.clientY - (rect.top + rect.height / 2)) * strength)
  }

  const reset = () => {
    x.set(0)
    y.set(0)
  }

  return (
    <motion.button
      ref={ref}
      type={type}
      className={className}
      onClick={onClick}
      onPointerMove={handleMove}
      onPointerLeave={reset}
      onBlur={reset}
      style={{ x: springX, y: springY }}
      whileTap={reduced ? undefined : { scale: 0.96 }}
      {...rest}
    >
      {children}
    </motion.button>
  )
}

export default MagneticButton
